export const ROUTE_SHIPPER_PROFILE = 'shipper-profile';
export const ROUTE_PROFILE_USER_INFO = 'profile-user-info';
export const ROUTE_PROFILE_COMPANY_INFO = 'profile-company-info';
export const ROUTE_PROFILE_PASSWORD_RESET = 'profile-password-info';
export const ROUTE_PROFILE_LOAD_SETTINGS = 'profile-load-settings';
